import { render, staticRenderFns } from "./LightWrapper.vue?vue&type=template&id=02e4b018&scoped=true&"
import script from "./LightWrapper.vue?vue&type=script&lang=js&"
export * from "./LightWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e4b018",
  null
  
)

export default component.exports